import axios from "axios";
import store from "../../redux_config/store";

const instance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_API_URL,
});
// Set the AUTH token for any request
instance.interceptors.request.use(function(config) {
    const authenticationState = store.getState()?.authentication;
    if (authenticationState.token) {
        config.headers["Access-Token"] = `${authenticationState.token}`;
    }
    if (authenticationState.externalToken) {
        config.headers["External-Token"] = `${authenticationState.externalToken}`;
    }
    config.headers["Access-Control-Allow-Origin"] = `*`;
    config.headers["Content-Type"] = `application/json; charset=utf-8`;
    return config;
});
export default instance;
